import { Link } from 'react-router';
import { Button, Icon } from 'semantic-ui-react';
import { ActionsCell } from './ActionsCell';

export const ViewDetailsButton = ({ to }: { to: string | number }) => (
  <ActionsCell>
    <Button icon basic circular size="mini" as={Link} to={`${to}`}>
      <Icon name="chevron right" link />
    </Button>
  </ActionsCell>
);
